import * as React from "react"
const SvgMenuHorizontal = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.23 14.357q-.618 0-1.059-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.44-.44 1.06-.44.618 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06a1.45 1.45 0 0 1-1.06.44Zm5.77 0a1.45 1.45 0 0 1-1.06-.44 1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06a1.45 1.45 0 0 1 1.06-.44q.618 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06a1.45 1.45 0 0 1-1.06.44m5.77 0q-.62 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.44-.44 1.06-.44.618 0 1.058.44.441.442.441 1.06 0 .62-.44 1.06t-1.06.44Z" />
  </svg>
)
export default SvgMenuHorizontal
